<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"></slot>
    </template>
    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Downloads
      </v-card-title>
      <v-card-text class="px-0">
        <empty-state
          v-if="isLoadingReports"
          color="accent"
        >
          <template v-slot:icon>
            <v-icon class="spinning" color="accent">mdi-sync</v-icon>
          </template>
          <template v-slot:description>
            Carregando relatórios
          </template>
        </empty-state>
        <empty-state
          v-else-if="reportsIsEmpty"
        >
          <template v-slot:icon>
            <v-icon>mdi-folder-open</v-icon>
          </template>
          <template v-slot:description>
            Nenhum relatório encontrado
          </template>
        </empty-state>
        <v-list
          v-else
          rounded
        >
          <v-list-item-group
            id="reports-download-list"
          >
            <v-list-item
              v-for="item in reports"
              :key="item.name"
              :href="item.url"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-pdf</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{item.name}}</v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {listFlightOrderProcessingReports} from "../../api/api-project"
  import {isEmpty} from "lodash/lang"
  import EmptyState from "../Helpers/EmptyState"

  export default {
    name: "OrderProcessingDownloads",
    components: {EmptyState},
    props: {
      idProcessing: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      tab: null,
      active: false,
      isLoadingReports: false,
      isLoadingProducts: false,

      reports: [],
      products: [],
    }),
    methods: {
      onOpen() {
        this.isLoadingReports = true
        this.isLoadingProducts = true

        const authToken = this.$apiAuth.getAuthToken()
        listFlightOrderProcessingReports(authToken, this.idProcessing)
          .then((res) => {
            this.reports = res.data.data.reports
          })
          .finally(() => {
            this.isLoadingReports = false
          })
      },
    },
    computed: {
      reportsIsEmpty() {
        return isEmpty(this.reports)
      },
    },
    watch: {
      active(newValue) {
        if (newValue) this.onOpen()
      },
    },
  }
</script>

<style scoped lang="scss">
</style>
